module.exports = __webpack_public_path__ + "static/media/icono_historial.b4a865d1.svg";